export default __webpack_public_path__ + "static/media/banner_board_desktop.1df69746.png";